module.exports = __webpack_public_path__ + "img/gcp.3110d860.png";